import React from "react";
import { formatToINR } from "../../../helpers/utility";
import packageIcon from "../../../assets/receptionistIcons/ipBilling/package.svg";
import billAmountIcon from "../../../assets/receptionistIcons/ipBilling/billAmount.svg";
import balanceIcon from "../../../assets/receptionistIcons/ipBilling/balance.svg";
import styles from "../../PatientsIP/ReceptionistIp/BillingIp/BillingIp.module.css";

const SummaryCard = ({ icon, label, value, sub, valueClassName = "" }) => (
  <article className={styles.summaryCard}>
    <img src={icon} alt="" className={styles.summaryIcon} />
    <div className={styles.summaryContent}>
      <p className={styles.summaryLabel}>{label}</p>
      <p className={`${styles.summaryValue} ${valueClassName}`.trim()}>{value}</p>
      {sub ? <p className={styles.summarySub}>{sub}</p> : null}
    </div>
  </article>
);

const renderBalanceValue = (balance) => {
  const amount = Number(balance) || 0;

  if (amount * -1 < 0) {
    return {
      text: formatToINR(amount * -1),
      className: styles.summaryValueDue,
    };
  }

  if (amount * -1 > 0) {
    return {
      text: `+${formatToINR(amount * -1) || 0}`,
      className: styles.summaryValueCredit,
    };
  }

  return {
    text: formatToINR(amount) || "₹0",
    className: "",
  };
};

const OpBillingSummaryCards = ({
  package_name,
  bill_amount,
  dueAmount,
  op_id,
}) => {
  const balanceDisplay = renderBalanceValue(dueAmount);

  return (
    <div className="op-billing-summary-row">
      <SummaryCard
        icon={packageIcon}
        label="Package name"
        value={package_name || "—"}
        sub="Assigned package"
      />
      <SummaryCard
        icon={billAmountIcon}
        label="Bill amount"
        value={formatToINR(bill_amount)}
        sub="Inclusive of package + services"
      />
      <SummaryCard
        icon={balanceIcon}
        label="Balance amount"
        value={balanceDisplay.text}
        sub="Balance with patient"
        valueClassName={balanceDisplay.className}
      />
    </div>
  );
};

export default OpBillingSummaryCards;
